export default __webpack_public_path__ + "static/media/pricing2.5aa3b03f.gif";